<template>
    <div>
        <div v-if="isLoading">
            <spinner></spinner>
        </div>
        <div v-else-if="cartItems.length <= 0" class="col-12">
            <div class="centerText fontColor mb50 mt100 semiBoldFont title-7">
                {{ label('shop.cart.empty') }}
            </div>
        </div>
        <div v-else class="col-12">
            <div class="col-12 cartProduct s-hide">
                <div class="productCartImage">
                    &nbsp;
                </div>
                <div class="productCartInfo">
                    &nbsp;
                </div>
                <div class="productCartPrice">
                    <span class="paragraph semiBoldFont line12 col-12 fontColor">{{ label('shop.cart.piece_price')}}</span>
                </div>
                <div class="productCartTotalPrice">
                    <span class="paragraph semiBoldFont line12 col-12 fontColor">{{ label('shop.cart.subtotal_incl') }}</span>
                </div>
                <div class="productCartActions">
                    &nbsp;
                </div>
            </div>
            <div v-for="(cartItem, index) in cartItems" :key="index" class="col-12 cartProduct">
                <div class="productCartImage">
                    <img src="/images/thema_stapelkorting_klein.png" class="bulkDiscountImageCart" v-if="cartItem.bulk_discount" alt="stapelkorting" />
                    <img :src="productThumbnail(cartItem)" :alt="cartItem.name" class="cart-product-image"/>
                </div>
                <div class="productCartInfo">
                    <a :href="`/${cartItem.url}/`">
                        <span class="title-7 semiBoldFont col-12 titleColor" v-if="cartItem.related_to_id !== null">{{cartItem.name }} (combideal)</span>
                        <span class="title-7 semiBoldFont col-12 titleColor" v-else>{{cartItem.name }}</span>
                    </a>
                    <span class="paragraph line12 mt5 col-12 fontColor extrasmall" v-if="!cartItem.is_event">ISBN: {{  cartItem.item.isbn }}</span>
                    <span class="paragraph line12 mt5 col-12 fontColor extrasmall" v-else>Artikelnummer: {{  cartItem.item.isbn }}</span>
                    <span class="paragraph line12 mt5 col-12 extrasmall greenColor" v-show="!cartItem.is_event" :class="availabilityColor(cartItem.item)">{{cartItem.item.availabilityInfo.label}}</span>

                    <CartQuantityUpdate :cart-item="cartItem" />
                </div>
                <div class="productCartPrice">
                    <span class="paragraph line12 col-12 fontColor">{{  $root.formatPrice(cartItem.piecePrice) }}</span>
                </div>
                <div class="productCartTotalPrice">
                    <span class="paragraph line12 col-12 fontColor">{{ $root.formatPrice(cartItem.linePriceIncl)}}</span>
                </div>
                <div class="productCartActions">
                    <button  @click.prevent="confirmDeleteLine(cartItem.id)" class="delete"><i class="fa fa-trash-o"></i></button>
                </div>
            </div>
        </div>


        <div class="col-12 mt30" v-if="cart && cartItems.length > 0">
            <div class="cartCheckOut" v-show="cart">
                <div class="paragraph col-12 fontColor">
                    <div class="col-12 p5-0">
                        <span class="cartCheckOutLeft">{{ label('shop.cart.subtotal_incl') }}</span>
                        <span class="cartCheckOutRight">{{ $root.formatPrice(cart.subTotalPrice) }}</span>
                    </div>
                    <div class="col-12 mb10" v-if="cart.discountAmount && cart.discountAmount > 0">
                        <span class="cartCheckOutLeft">{{ label('shop.cart.discount') }}</span>
                        <span class="cartCheckOutRight">-{{ $root.formatPrice(cart.discountAmount) }}</span>
                    </div>
                    <div class="col-12 p5-0" v-if="cart.bulkDiscountAmount && cart.bulkDiscountAmount > 0">
                        <span class="cartCheckOutLeft">{{ label('shop.cart.bulk_discount') }} {{ cart.bulkDiscountPercentage }}%</span>
                        <span class="cartCheckOutRight">-{{ $root.formatPrice(cart.bulkDiscountAmount) }}</span>
                    </div>
                    <div class="col-12 p5-0">
                        <span class="cartCheckOutLeft">{{ label('shop.cart.delivery_costs') }}</span>
                        <span class="cartCheckOutRight">{{ cart.deliveryPrice === 0 ? label('shop.cart.delivery_costs.free') : $root.formatPrice(cart.deliveryPrice)}}</span>
                    </div>
                    <div class="col-12 borderTop p5-0 mb20">
                        <span class="cartCheckOutLeft semiBoldFont">{{ label('shop.cart.total_incl') }}</span>
                        <span class="cartCheckOutRight semiBoldFont">{{ $root.formatPrice(cart.totalPriceIncl) }}</span>
                    </div>

                    <div class="col-12 p5-0" v-for="tax in taxLines">
                        <span class="cartCheckOutLeft">{{ tax.label }}</span>
                        <span class="cartCheckOutRight">{{ $root.formatPrice(tax.total) }}</span>
                    </div>
                    <div class="col-12 borderTop p5-0">
                        <span class="cartCheckOutLeft">{{ label('shop.cart.total_excl') }}</span>
                        <span class="cartCheckOutRight">{{ $root.formatPrice(cart.totalPriceExcl) }}</span>
                    </div>
                </div>
            </div>
            <div class="cartCheckOut fontColor">
                    <span class="title-6 semiBoldFont col-12 titleColor">{{ label('shop.cart.discount_code')}}</span>

                    <div v-if="discounts" v-for="discount in discounts" class="inline-flex flexBetween flexCenter w100p mt5">
                        <div class="paragraph fontColor" v-text="`${discount.code}`"></div>
                        <div class="paragraph fontColor fs11 discount-price" v-if="discount.amount">-{{ formatIntPrice(discount.amount) }}</div>
                        <button class="delete small" @click.prevent="destroyDiscountCode(discount.code)"><i
                            class="fa fa-close"></i></button>
                    </div>

                <div class="couponCode col-12">
                    <discount-code></discount-code>
                </div>
            </div>
        </div>

        <div v-if="cart && cartItems.length > 0">
            <a :href="routeOrder" class="floatRightI button green mt30" v-if="hasEbooks" @click.prevent="openEbookModal">{{ label('shop.cart.continue_order') }}</a>
            <a :href="routeOrder" class="floatRightI button green mt30" v-else-if="hasAudiobooks" @click.prevent="openAudiobookModal">{{ label('shop.cart.continue_order') }}</a>
            <a :href="routeOrder" class="floatRightI button green mt30" v-else>{{ label('shop.cart.continue_order') }}</a>
        </div>

        <div class="modal-fancybox" :id="modalId" style="display: none; max-width: 600px;">
            <div class="col-12 centerText">
                <h5 v-text="label('shop.cart.delete.title')" class="boldFont col-12 ml5 mt20 title-6"></h5>
                <p v-text="label('shop.cart.delete.sure')" class="paragraph col-12 ml5 mt10 mb30"></p>
                <div class="button-group-cart">
                    <button class="button big grey mr5 ml5 mb5" @click.prevent="cancelDeleteLine"
                            v-text="label('shop.cart.delete.cancel')"></button>
                    <button class="button big blue mr5 ml5 mb5" @click.prevent="destroyLine(nominatedItem.id)"
                            v-text="label('shop.cart.delete.confirm')"></button>
                </div>
            </div>
        </div>

        <div class="modal-fancybox" id="ebookModal" style="max-width: 600px;">
            <div class="col-12 centerText">
                <h5 v-text="label('shop.cart.e-book.title')" class="boldFont col-12 ml5 mt20 title-6"></h5>
                <p v-text="label('shop.cart.e-book.text')" class="paragraph col-12 ml5 mt10 mb30"></p>
                <div class="button-group-cart">
                    <button class="button big grey mr5 ml5 mb5" @click.prevent="cancelDeleteLine"
                            v-text="label('shop.cart.delete.cancel')"></button>
                    <a :href="routeOrder" class="button big blue mr5 ml5 mb5"
                            v-text="label('shop.cart.e-book.confirm')"></a>
                </div>
            </div>
        </div>

        <div class="modal-fancybox" id="audiobookModal" style="max-width: 600px;">
            <div class="col-12 centerText">
                <h5 v-text="label('shop.cart.audiobook.title')" class="boldFont col-12 ml5 mt20 title-6"></h5>
                <p v-text="label('shop.cart.audiobook.text')" class="paragraph col-12 ml5 mt10 mb30"></p>
                <div class="button-group-cart">
                    <button class="button big grey mr5 ml5 mb5" @click.prevent="cancelDeleteLine"
                            v-text="label('shop.cart.delete.cancel')"></button>
                    <a :href="routeOrder" class="button big blue mr5 ml5 mb5"
                       v-text="label('shop.cart.audiobook.confirm')"></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CartQuantityUpdate from './CartQuantityUpdate';
import Spinner from './Spinner';
import DiscountCode from "./DiscountCode";
import translations from "../mixins/translations";
import {EventBus} from "../../events";

export default {
    name: "full-cart",
    mixins: [translations,],
    components: {
        DiscountCode,
        CartQuantityUpdate,
        Spinner
    },
    props: {
        lang: {
            required: false,
            type: Object
        },
        currency: {
            required: false,
            type: String,
            default: "EUR"
        },
        routeOrder: {
            required: false,
            type: String
        },
        routeCollection: {
            required: false,
            type: String
        }
    },
    data() {
        return {
            show: false,
            nominatedItemId: null,
            locked: false,
            currentLang: {},
        }
    },
    methods: {
        changeLang() {
            _.forEach(this.lang, (value, key) => {
                this.currentLang[key] = value;
            })
        },
        cancelDeleteLine() {
            this.nominatedItemId = null;
            this.closeModal();
        },
        confirmDeleteLine(cart_item_id) {
            this.nominatedItemId = cart_item_id;
            this.openModal();
        },
        availabilityColor (item) {
          let colors = {
            'not-available': 'redColor',
            'soon' : 'orangeColor',
            'available' : 'greenColor',
          };
          return colors[item.availabilityInfo.availability] ?? colors['not-available'];
        },
        destroyDiscountCode(discountCode) {
            if (!this.locked) {
                this.locked = true;
                return this.$store.dispatch('cart/deleteDiscountCode', {discountCode})
                    .finally(() => {
                        this.locked = false;
                    });
            }
        },
        destroyLine(cart_item_id) {
            if (!this.locked) {
                this.locked = true;
                return this.$store.dispatch('cart/destroyLine', {cart_item_id})
                    .finally(() => {
                        this.nominatedItemId = null;
                        this.locked = false;
                        this.closeModal();
                    });
            }
        },
        toggle() {
            this.show = !this.show;
        },
        formatIntPrice(price) {
            return this.$root.formatPrice(price, this.currency, true);
        },
        formatFloatDiscount(discount) {
            // discount * 100 will have decimal errors, therefore (discount * 1000) / 10.
            let discountCalculated = (discount * 1000) / 10;

            if (discountCalculated < 0) {
                discountCalculated = 0;
            }

            return `${discountCalculated}%`;
        },
        productInfo(cartItem, field, defaultValue) {
            return _.get(cartItem.product, field, defaultValue);
        },
        productThumbnail(cartItem) {
            if (cartItem.thumbnail) {
                return cartItem.thumbnail;
            }
            return '/images/products/no-photo.jpg';
        },
        openModal() {
            $.fancybox.open({
                src: `#${this.modalId}`,
            });
        },
        openEbookModal() {
            $.fancybox.open({
                src: `#ebookModal`,
            });
        },
        openAudiobookModal() {
            $.fancybox.open({
                src: `#audiobookModal`,
            });
        },
        closeModal() {
            $.fancybox.close({
                src: `#${this.modalId}`,
            });
        },
    },
    computed: {
        askForConfirmation() {
            return (this.nominatedItemId && !this.locked);
        },
        cart() {
            return this.$store.state.cart.cart;
        },
        deliveryPrice() {
            if (this.cart) {
                return this.cart.deliveryPrice;
            }
            return 0;
        },
        deliveryTaxRate() {
            if (this.cart) {
                return this.cart.deliveryCostTaxRate;
            }
            return 0;
        },
        hasDiscount() {
            let discount = _.get(this.cart, 'discountAmount', 0);
            return (discount > 0);
        },
        hasVAT() {
            if (_.size(this.cartItems) == 0) {
                return false;
            }
            return (_.head(this.cartItems).tax > 0);
        },
        hasEbooks() {
            if(this.cart){
                return this.cart.hasEbooks;
            }
            return false;
        },
        hasAudiobooks() {
            if(this.cart){
                return this.cart.hasAudiobooks;
            }
            return false;
        },
        isEmpty() {
            return this.cartItems && !this.cartItems.length && !this.isLoading;
        },
        isLoading() {
            return !this.cart || this.locked;
        },
        lineCount() {
            return this.cartItems.length;
        },
        nominatedItem() {
            return _.find(this.$store.state.cart.cartItems, (cartItem) => {
                return cartItem.id === this.nominatedItemId
            });
        },
        cartItems() {
            return this.$store.state.cart.cartItems.filter((item) => !item.is_gift);
        },
        discounts() {
            if (this.cart) {
                return this.cart.discounts;
            }
            return [];
        },
        taxLines() {
            if (this.cart) {
                return this.cart.taxLines;
            }
            return [];
        },
        totalPriceExcl() {
            if (this.cart) {
                return this.cart.totalPriceExcl;
            }
            return 0;
        },
        totalPriceIncl() {
            if (this.cart) {
                return this.cart.totalPriceIncl;
            }
            return 0;
        },
        modalId() {
            return 'full-cart-remove-modal';
        },
    },
    mounted() {
        this.changeLang();

        EventBus.$on('destroyLine', (cartItemId) => {
            this.nominatedItemId = cartItemId;
            this.openModal();
        });
    }
}
</script>
<style lang="scss" scoped>
.cart-product-image {
    max-height: 200px;
}

.cart-product-info {
    margin: auto 0;
}

.discount-price {
    margin-left: auto;
    margin-right: 1.5rem;
}

@media screen and (max-width: 600px) {
    .cart-product-image {
        max-height: 100px;
    }

    .s-flex-column {
        flex-direction: column;
    }
}

@media screen and (max-width: 500px) {
    .cart-amount-price .cart-price {
        min-width: 60px;
    }
}
</style>
